// framework
import PropTypes from "prop-types";
import { useEffect } from "react";
import { audio } from "services/audioManager";
// styles
import styles from "./Timer.module.scss";
// constants
import { GAME_STATES } from "constants/constants";
import { SFX } from "constants/audio";

export default function Timer({ gameState, roomState }) {
    const timeLeft = roomState?.mdmdData?.timer ?? 0;
    const isAnsweringQuestion = gameState === GAME_STATES.ANSWERING;
    const isChoosingCategory = gameState === GAME_STATES.CATEGORY_SELECT;
    const showSection = (isChoosingCategory || isAnsweringQuestion) && timeLeft > 0;

    //useEffect(() => {
    //    if (!showSection) return;
    //    const ac = new AbortController();
    //    audio.playSfx(SFX.TIMER_START, { signal: ac.signal });
    //    return () => ac.abort();
    //}, [showSection]);

    useEffect(() => {
        if (!showSection) return;
        const ac = new AbortController();

        if (timeLeft > 0 && timeLeft <= 10) {
            const sfx = timeLeft % 2 === 0 ? SFX.TIMER_TICK : SFX.TIMER_TOCK;
            audio.playSfx(sfx, { signal: ac.signal });
        }
        if (timeLeft === 0) {
            audio.playSfx(SFX.TIMES_UP, { signal: ac.signal });
        }
        return () => ac.abort();
    }, [timeLeft, showSection]);

    return (
        <section className={styles.timer} data-show={showSection ? "true" : "false"} data-testid="timer-view" >
            <div className={styles.box}>{timeLeft}</div>
        </section>
    );
}

Timer.propTypes = {
    gameState: PropTypes.any,
    roomState: PropTypes.object,
};